import KitAddToCartButton from '@/components/CartActions/kits/KitAddToCartButton.vue';
import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown';

export const initKitCartActions = async (mountId: string) => {
  if (!document.getElementById(mountId)) {
    return;
  }

  await mountCoreVueApp(KitAddToCartButton, `#${mountId}`, {}, (app) => {
    app.directive('global-keydown', GlobalKeyDownDirective);
  });
};
